import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { requestBuilder } from '../../http/RequestBuilder';
import { pendingJointInvitations } from '../state/PendingJointInvitationsAtoms';
import { type PendingJointInvitation } from '../types/PendingJointInvitations';

const useGetJointInvites = requestBuilder.query<PendingJointInvitation[]>({
    endpoint: '/api/bank-accounts/joint-invite',
    queryKey: '/api/bank-accounts/joint-invite',
});

export const useGetPendingJointInvites = ({
    enabled = true,
}: { enabled?: boolean } = {}) => {
    const [storedPendingInvitations, storePendingInvitations] = useAtom(
        pendingJointInvitations,
    );
    const {
        data: jointInvites,
        isLoading,
        refetch,
    } = useGetJointInvites(
        {},
        {
            enabled,
        },
    );

    useEffect(() => {
        if (jointInvites) {
            storePendingInvitations(jointInvites);
        }
    }, [jointInvites]);

    return {
        pendingJointInvitations: storedPendingInvitations,
        isLoading,
        refetch,
    };
};

export const useDeclinePendingJointInvite = requestBuilder.mutation<
    { success: true },
    { bankAccountId: string }
>({
    method: 'POST',
    endpoint: () => `/api/bank-accounts/decline-joint-invite/`,
});
